import React from 'react';
import { Route } from 'react-router';

import Edit from './edit';
import Users from './users';
import Companies from './all';
import Add from './add';
import AddUser from './add-user';
import Delete from './delete';
import EditUser from '../edit-user';

export default () => (
  <div id="dashboard">
    <Route exact path="/settings/companies" component={Companies} />

    <Route exact path="/settings/companies/add" component={Add} />

    <Route exact path="/settings/companies/:id/add-user" component={AddUser} />

    <Route exact path="/settings/companies/:id/delete" component={Delete} />

    <Route exact path="/settings/companies/user/:id" component={EditUser} />

    <Route path="/settings/companies/:id/users" component={Users} />

    <Route path="/settings/companies/:id/edit" component={Edit} />
  </div>
);



// WEBPACK FOOTER //
// ./src/views/settings/companies/index.js